import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import styles from './assets/provider-create-screen.module.scss';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/ProviderForm';
import Loader from 'src/components/Loader';
import { IServiceType } from 'src/types/service-types';
import { IServiceLocation } from 'src/types/service-locations';

import { QueryParams } from 'src/types/grid';
import { Paginated } from 'src/services/api-handlers/pagination';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';
import { IProvider } from '../../../../../../types/provider';
import { toast } from 'react-toastify';

export interface StateProps {
    serviceTypes: Paginated<IServiceType>;
    providers: Paginated<IProvider>;
    serviceLocations: Paginated<IServiceLocation>;
    inProgress: boolean;
}

export interface DispatchProps {
    getServiceTypes: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getServiceLocations: (params: QueryParams) => void;
}
export interface OwnProps {}
export interface Props extends StateProps, DispatchProps, OwnProps {}

const ProviderCreateScreen: React.FunctionComponent<Props> = (props) => {
    const [files, setFiles] = useState([]);
    const [signDoc, setSignDoc] = useState(null);

    const {
        getServiceTypes,
        getServiceLocations,
        providers,
        getProviders,
        inProgress,
        serviceTypes,
        serviceLocations,
    } = props;

    useEffect(() => {
        getServiceTypes({
            page: 1,
            itemsPerPage: 1200,
        });
        getProviders({ page: 1, itemsPerPage: 1200 });
        getServiceLocations({
            page: 1,
            itemsPerPage: 1200,
        });
    }, [getServiceTypes, getServiceLocations, getProviders]);

    const serValues: any = [];
    serviceTypes.list.forEach((serv: any) => {
        const title = serv.title ? serv.title : serv.cpt;

        serValues.push({ ...serv, title });
    });

    const provValues: any = [];
    providers.list.forEach((prov: any) => {
        const title = prov.fullName ? prov.fullName : '';

        provValues.push({ id: prov.id, title });
    });

    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        if (!!signDoc) {
            handleSubmit(e);
        } else {
            toast.error('Sign Doc is required');
            return false;
        }
    };
    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'PROVIDERS', path: routes.PROVIDERS_LIST },
                    { name: `ADD NEW PROVIDER`, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}>
                {inProgress ? <Loader /> : null}
                <Form
                    handleSub={handleSub}
                    serviceTypes={serValues}
                    serviceLocations={serviceLocations}
                    files={files}
                    signDoc={signDoc}
                    setSignDoc={setSignDoc}
                    providers={provValues}
                    initialValues={{
                        serviceLocations: [],
                        serviceTypes: [],
                        providers: [],
                        referredByDropDown: null,
                        isGetAdvance: true,
                        //   ...inVal,
                    }}
                    setFiles={setFiles}
                    removeFile={(id) => {
                        files.splice(id, 1);
                        setFiles([...files]);
                    }}
                />
            </div>
        </AdminLayout>
    );
};

export default ProviderCreateScreen;
